import { fetchSEO } from '../../lib/blog/api'
import Seo from '../../components/blog/seo'
import LandingWrapper from '../../components/landing/elements/LandingWrapper'
import PickupLanding from '../../components/PickupLanding'

export async function getStaticProps () {
  const seo = await fetchSEO('ivystore-pickup')

  return {
    props: {
      seo
    },
    revalidate: 60 * 60 * 24,
  }
}

export default function PickupIndex ({ seo }) {
  return (
    <>
      <Seo seo={seo} />

      <LandingWrapper className={'mt-4'}>
        <PickupLanding
          stateData={{
            code: 'whole-us',
            name: 'United States',
          }}
        />
      </LandingWrapper>
    </>
  )
}